import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "./FrontEnd/Main/Home"
import About from './FrontEnd/Main//About';
import Cart from './FrontEnd/Main//Cart'
import PageService from './FrontEnd/Main//PageService';
import Login from './FrontEnd/Main/Login';
import PageProdutos from './FrontEnd/Main/PageProdutos'
import Checkout from './FrontEnd/Main/CheckOut';
import PageDetails from './FrontEnd/Main/PageDetails'
import PageDetailsService from './FrontEnd/Main/PageDetailsService';
import PageCheckoutservice from './FrontEnd/Main/PageCheckout_service';
import PageUserErro from './FrontEnd/Main/PageUserErro';
//----------User Dashboard ----------------------------
import PageUserUpdate from './FrontEnd/Main/PageUserUpdate';
import PageUser from './FrontEnd/Main/PageUser';
import PageUserOrders from './FrontEnd/Main/PageUserOrders';
import PageUserprofile from './FrontEnd/Main/PageUserprofile';
//----= routes to Service with high level of selling 
import PrivateRoute from './FrontEnd/Integration/PrivateRoute';

// ----- Tou Aki Service online




function App() {
  return (

     <BrowserRouter>
      {/* Navigation */}
      <nav>
       
      </nav>

      {/* Routes */}
      <Routes>
              {/* Routes Para Clientes */}

      <Route path="/Home" element={ <PrivateRoute>  <Home/> </PrivateRoute> }   />
      <Route path="/" element={<Home/>} />
      <Route path="/about" element={< About/>} />
      <Route path="/cart" element={<Cart/>} />
      <Route path="/Details/*" element={<PageDetails/>} />
       <Route path="/Agendar/*" element={<PageDetailsService/>} />
       <Route path="/login/*" element={<Login/>} />
      <Route path="/Produtos/*" element={<PageProdutos/>} />
      <Route path="/checkout"  element={<PrivateRoute>  <Checkout/> </PrivateRoute>} />
      <Route path="/User/Update"  element={<PrivateRoute>   <PageUserUpdate/>  </PrivateRoute>} />
        <Route path="/User/Profile"  element={<PrivateRoute>   <PageUserprofile/>  </PrivateRoute>} />
      <Route path="/User/Painel"  element={ <PrivateRoute>  <PageUser/> </PrivateRoute>} />
      <Route path="/User/Orders"  element={<PrivateRoute>  <PageUserOrders/> </PrivateRoute>}  />
       <Route path="/User/info"  element={<PrivateRoute> < PageUserprofile/>  </PrivateRoute>} />
      <Route path="/Agenda/*"  element={<PageService/>} />
      <Route path='/Service/Checkout' element={<PrivateRoute> <PageCheckoutservice/>  </PrivateRoute>}/>
      <Route path="/UserErro" element={<PageUserErro />} />

         


        
       
        
          
        
        
       
      </Routes>
    </BrowserRouter>
  );
}

export default App;
